import type { CardBrand } from "../../../add-card/components/card-fields.types";

const BRANDS: readonly CardBrand[] = [
  "visa",
  "mastercard",
  "maestro",
  "american_express",
  "discover",
  "diners_club",
];

export function toCardBrand(brand?: string): CardBrand {
  return BRANDS.find((known) => known === brand) ?? "unknown";
}
